"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralLinkTextToJSON = exports.ReferralLinkTextFromJSONTyped = exports.ReferralLinkTextFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ReferralLinkTextFromJSON(json) {
    return ReferralLinkTextFromJSONTyped(json, false);
}
exports.ReferralLinkTextFromJSON = ReferralLinkTextFromJSON;
function ReferralLinkTextFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'header': !(0, runtime_1.exists)(json, 'header') ? undefined : json['header'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'relationshipType': (0, _1.RelationshipTypeFromJSON)(json['relationshipType']),
    };
}
exports.ReferralLinkTextFromJSONTyped = ReferralLinkTextFromJSONTyped;
function ReferralLinkTextToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'header': value.header,
        'description': value.description,
        'relationshipType': (0, _1.RelationshipTypeToJSON)(value.relationshipType),
    };
}
exports.ReferralLinkTextToJSON = ReferralLinkTextToJSON;
